"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderArrowRight = exports.renderArrowLeft = exports.standardColors = exports.renderButton = exports.render = exports.hitTest = exports.create = void 0;
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var create = function (text, x, y, onClick) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (onClick === void 0) { onClick = function () { }; }
    var b = {
        text: text,
        x: x,
        y: y,
        w: 100,
        h: 40,
        bevel: 8,
        isOver: false,
        isDown: false,
        onClick: onClick,
        onMouseOver: function () { },
        isVisible: true,
        isUnlocked: false,
        isDisabled: false,
        inGameSpace: false,
        feather: 0,
        renderer: exports.renderButton,
    };
    return b;
};
exports.create = create;
var hitTest = function (buttons, x, y, official) {
    var over = null;
    for (var i = 0; i < buttons.length; i++) {
        var c = buttons[i];
        if (!c.isVisible) {
            continue;
        }
        if (clickEater_sidecar_1.clickEater.isCursorEaten()) {
            c.isOver = false;
            c.isDown = false;
            continue;
        }
        var wasOver = c.isOver;
        if (official) {
            c.isOver = false;
        }
        var tx = x;
        var ty = y;
        if (c.inGameSpace && official) {
            var gs = voyageCamera_sidecar_1.voyageCamera.getUiPositionToGamePosition(x, y);
            tx = gs.x;
            ty = gs.y;
        }
        if (tx >= c.x - c.feather && ty >= c.y - c.feather) {
            if (tx <= c.x + c.w + c.feather && ty <= c.y + c.h + c.feather) {
                over = c;
                // console.log('button hit test over', official)
                if (official) {
                    c.isOver = true;
                    if (!wasOver) {
                        c.onMouseOver(c);
                        voyageSounds_sidecar_1.voyageSounds.playbuttonMouseOver();
                    }
                    if (c.isDown && !clickEater_sidecar_1.clickEater.isLeftDownRegardless()) {
                        c.isDown = false;
                        voyageSounds_sidecar_1.voyageSounds.playButtonClick();
                        c.onClick(c);
                        clickEater_sidecar_1.clickEater.tempEat();
                    }
                    else {
                        c.isDown = false;
                        if (clickEater_sidecar_1.clickEater.isLeftDownRegardless()) {
                            c.isDown = true;
                            clickEater_sidecar_1.clickEater.tempEat();
                        }
                        else {
                        }
                    }
                }
                // if (clickEater.isLeftFirstDownAndUneaten()) {
                //   // goatUiConfirm.setOpen(true)
                // }
            }
        }
        if (official) {
            if (!c.isOver) {
                c.isDown = false;
            }
        }
    }
    return over !== null;
};
exports.hitTest = hitTest;
var render = function (g, buttons, texts, layer) {
    for (var i = 0; i < buttons.length; i++) {
        var c = buttons[i];
        if (!c.isVisible) {
            continue;
        }
        c.renderer(g, c, texts, layer);
    }
};
exports.render = render;
var renderButton = function (g, c, texts, layer) {
    exports.standardColors(g, c);
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, c.x, c.y, c.w, c.h, c.bevel);
    g.fill();
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelArea(g, c.x, c.y, c.w, c.h, c.bevel);
    g.stroke();
    var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, c.x + 16, c.y + 18, layer);
    stevieTexts2_sidecar_1.stevieTexts2.setText(_text, c.text);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3);
    texts.push(_text);
};
exports.renderButton = renderButton;
var standardColors = function (g, c) {
    if (c.isOver) {
        if (c.isDown) {
            g.fillStyle(voyageColors_sidecar_1.voyageColors.purpleDull, 1);
        }
        else {
            g.fillStyle(voyageColors_sidecar_1.voyageColors.purple, 1);
        }
    }
    else {
        g.fillStyle(voyageColors_sidecar_1.voyageColors.purpleDull, 0.9);
    }
    if (c.isUnlocked) {
        g.fillStyle(0xffffff, 0.5);
    }
    if (c.isDisabled) {
        g.fillStyle(0x777777, 0.5);
    }
    var lineColor = voyageColors_sidecar_1.voyageColors.g3;
    if (c.isUnlocked) {
        lineColor = 0xffffff;
    }
    if (c.isDisabled) {
        lineColor = 0x777777;
    }
    g.lineStyle(3, lineColor);
};
exports.standardColors = standardColors;
var renderArrowLeft = function (g, c) {
    exports.standardColors(g, c);
    var x = c.x;
    var y = c.y;
    var w = c.w;
    var h = c.h;
    var bevel = 10;
    var bevel2 = 10;
    g.beginPath();
    g.moveTo(x, y + h / 2 - bevel2 / 2);
    g.lineTo(x + bevel, y);
    g.lineTo(x + w, y);
    g.lineTo(x + w, y + h);
    g.lineTo(x + bevel, y + h);
    g.lineTo(x, y + h / 2 + bevel2 / 2);
    g.closePath();
    g.fill();
    g.stroke();
};
exports.renderArrowLeft = renderArrowLeft;
var renderArrowRight = function (g, c) {
    exports.standardColors(g, c);
    var x = c.x;
    var y = c.y;
    var w = c.w;
    var h = c.h;
    var bevel = 10;
    var bevel2 = 10;
    g.beginPath();
    g.moveTo(x + w, y + h / 2 - bevel2 / 2);
    g.lineTo(x + w - bevel, y);
    g.lineTo(x, y);
    g.lineTo(x, y + h);
    g.lineTo(x + w - bevel, y + h);
    g.lineTo(x + w, y + h / 2 + bevel2 / 2);
    g.closePath();
    g.fill();
    g.stroke();
};
exports.renderArrowRight = renderArrowRight;
// export const setVisible(c: IGoatGButton, isVisible: boolean) {
//   c.isVisible = isVisible
//   stevieTexts2.setVisible(c., isVisible)
// }
